import React from "react";
import { activityPhotos, sampleExercises } from "../data/landing";
export function CollectionSection() {
  return <section className="bg-paper" data-id="element-25" data-mp="3840dfuk1qggd">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-26" data-mp="380ulm7k190gy">
        <h2 className="text-center font-display text-2xl font-bold text-ink md:text-3xl" data-id="element-27" data-mp="2u47krtoylq5r">¿Qué recibes con tu compra?</h2>

        <div className="mt-10 grid gap-10 md:grid-cols-[1fr_1.1fr] md:gap-14" data-id="element-28" data-mp="2z2iy4eegqisq">
          <div data-id="element-29" data-mp="3mt4tp67a6alu">
            <p className="text-sm font-extrabold uppercase tracking-wide text-plum" data-id="element-30" data-mp="3msn06hc06ahm">Colección completa</p>
            <h3 className="mt-1 font-display text-2xl font-bold text-ink" data-id="element-31" data-mp="3qsngy8mkqxru">MegaPack Arteterapia</h3>
            <p className="mt-4 text-lg leading-relaxed text-ink" data-id="element-32" data-mp="3d1s46l8yfwiz">
              Una colección de <strong className="font-extrabold" data-id="element-33" data-mp="3hzk33z80oiwo">6 volúmenes digitales</strong> con más de 50 técnicas
              y ejercicios creativos guiados.
            </p>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-34" data-mp="ecju2g0jgtve">
              Cada volumen aborda distintas dimensiones del bienestar y la exploración personal mediante actividades
              visuales, escritura y creatividad.
            </p>

            <p className="mt-8 font-bold text-ink" data-id="element-35" data-mp="1pg4wa0m5dwac">Encontrarás ejercicios como:</p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-36" data-mp="236gp61qk3z2j">
              {sampleExercises.map(e => <li key={e} className="rounded-lg border border-line bg-cream px-3 py-1.5 text-sm font-semibold text-ink" data-id="element-37" data-mp="1ye6vcambmeuz">
                  {e}
                </li>)}
            </ul>
            <p className="mt-3 text-muted" data-id="element-38" data-mp="28403t2r62dv0">…y muchas actividades más.</p>
          </div>

          <div data-id="element-39" data-mp="2m3hxnwjbkhb8">
            <div className="grid grid-cols-2 gap-4" data-id="element-40" data-mp="2m4152jbcfnb0">
              {activityPhotos.map(p => <figure key={p.src} className="flex flex-col" data-id="element-41" data-mp="2h5zkfty9rfxf">
                  <img src={p.src} alt={p.alt} loading="lazy" className="w-full rounded-xl border border-line bg-paper shadow-md" data-id="element-42" data-mp="rpqeo6f3ol34" />
                  <figcaption className="mt-2 text-center text-sm font-bold text-ink" data-id="element-43" data-mp="2mv9axddpe43t">{p.title}</figcaption>
                </figure>)}
            </div>
            <p className="mt-4 rounded-xl bg-lilac px-4 py-3 text-center text-sm text-plum" data-id="element-44" data-mp="2wrcn7c29rj4h">
              <strong className="font-extrabold" data-id="element-45" data-mp="30tz8eu4fq5sp">Capturas reales del material.</strong> Así se ven las páginas que
              recibirás: listas para imprimir y completar a tu manera.
            </p>
          </div>
        </div>
      </div>
    </section>;
}